import Text from 'components/Text/Text';
import { UserRoles } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import React, { useContext } from 'react';
import { IPushesViewContext, PushesViewContext } from '../../pushesViewContext/pushesViewState/pushesViewContext';
import FirmwareField from './components/FirmwareField';
import TabletAppField from './components/TabletAppField';
import LastSyncField from './components/LastSyncField';
import UpdateHistoryControlPanel from './components/UpdateHistoryControlPanel/UpdateHistoryControlPanel';
import UpdateHistoryList from './components/UpdateHistoryList/UpdateHistoryList';
import { PaginationComponent } from 'components/PaginationComponent/PaginationComponent';
import style from './Info.module.scss';

const Info: React.FC = () => {
	const { changeCurrentPage, currentPage, countOfItems, softwareUpdates } =
		useContext<IPushesViewContext>(PushesViewContext);
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	return (
		<div className={style.container} data-test="Info">
			<div className={style.fieldsWrapper}>
				<Text
					className={style.heading}
					translationNameSpace="form"
					translationKey="infoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				{hasAccess && (
					<>
						<FirmwareField />
						<TabletAppField />
					</>
				)}
				<LastSyncField />
			</div>
			{hasAccess && (
				<div className={style.fieldsWrapper}>
					<Text
						className={style.heading}
						translationNameSpace="form"
						translationKey="updateHistoryHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<UpdateHistoryControlPanel />
					<UpdateHistoryList />
					<PaginationComponent
						currentPage={currentPage}
						countOfItems={countOfItems}
						entitiesCount={softwareUpdates.count}
						changeCurrentPage={changeCurrentPage}
					/>
				</div>
			)}
		</div>
	);
};

export default Info;
